import { OrderEntity } from './order';
import { OrderData } from './order-data';

// 采购状态
export enum PurchaseStatus {
  QuotePending = 1,      // 待报价（采购员待处理）
  Undeclared = 5,        // 待申报（采购员待提单）
  Declared = 11,         // 已申报（审批中）
  Completed = 16,        // 已完成
  Returned = 21,         // 已退回
}

// 采购单 Tab/KPI 场景组
export enum PurchaseTabScene {
  QuotePending = 'tab_quote_pending',
  DeliveryPending = 'tab_delivery_pending',
  Undeclared = 'tab_undeclared',
  Declared = 'tab_declared',
  Finished = 'tab_finished',
  FinancialPending = 'tab_financial_pending',
}

// 采购单创建来源
export enum PurchaseSource {
  Return = 1,     // 打回创建
  Decision = 2,   // 决策创建
}

// 采购联合信息
export interface PurchaseInfo {
  purchase: PurchaseEntity;
  order?: OrderEntity;
  orderData?: OrderData;
}

// 采购单实体
export interface PurchaseEntity {
  purchaseNo: string;
  orderNo: string;
  brand?: string;
  storeId?: number;
  status: PurchaseStatus;

  // Creation Requirements (Creation)
  activationStatus?: number;
  lockStatus?: number;
  pickupMethod?: string;
  requirementRemark?: string;

  // T1 报价信息 (Quote)
  quotedPrice?: number;
  quotedTime?: string;
  supplierName?: string;
  remark?: string;
  source?: PurchaseSource;
  activationDate?: string;

  // T2 微签发货 (Delivery)
  signatureUrl?: string;
  logisticsNo?: string;
  signatureTime?: string;

  // T3 申报审批 (Declare)
  wechatApprovalNo?: string;
  invoiceType?: string;
  taxAmount?: number;
  lockFee?: number;
  lockingFee?: number;
  accessoriesFee?: number;
  applyTotal?: number;
  deviceImei?: string;
  purchaseVoucherUrl?: string;
  declareTime?: string;

  // T6/T7 财务支付 (Payment)
  paymentVoucherNo?: string;
  paymentType?: string;

  createdAt: string;
  updatedAt: string;
}
